export default __webpack_public_path__ + "static/media/phone_icon.db27ab4e.png";